export default {
      id: "arrow-drop-right-usage",
      viewBox: "0 0 15 14",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#arrow-drop-right",
      toString: function () {
        return this.url;
      }
    }